<app-header></app-header>
<app-leftsidebar></app-leftsidebar>
<main class="all-shops-shell">
<div class="all-shops-page">
  <div class="shops-head">
    <div>
      <h1>All Shops</h1>
      <p class="lede">Creators selling maps, modules and campaigns on WorldTumbler.</p>
    </div>
    <label class="shops-search">
      <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
      <input type="search" placeholder="Search shops" [(ngModel)]="searchTerm" aria-label="Search shops" />
    </label>
  </div>

  @if (loading) {
    <div class="shop-grid" aria-busy="true" aria-label="Loading shops">
      @for (s of skeletons; track s) {
        <div class="shop-card shop-card--skeleton">
          <span class="shop-skel shop-skel--banner"></span>
          <span class="shop-skel shop-skel--logo"></span>
          <div class="shop-card-body">
            <span class="shop-skel shop-skel--title"></span>
            <span class="shop-skel shop-skel--line"></span>
            <span class="shop-skel shop-skel--line is-short"></span>
          </div>
        </div>
      }
    </div>
  } @else if (loadFailed) {
    <div class="shops-empty">
      <span class="shops-empty-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><line x1="12" y1="7.5" x2="12" y2="12.5" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
      </span>
      <h3>Couldn't load shops</h3>
      <button type="button" class="wt-btn-primary" (click)="load()">Try again</button>
    </div>
  } @else if (filteredVendors.length === 0) {
    <div class="shops-empty">
      <span class="shops-empty-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M3 9l1.5-5h15L21 9" /><path d="M4 9v11h16V9" /><path d="M9 20v-6h6v6" /></svg>
      </span>
      @if (searchTerm.trim()) {
        <h3>No shops match “{{ searchTerm }}”</h3>
        <button type="button" class="shops-text-btn" (click)="searchTerm = ''">Clear search</button>
      } @else {
        <h3>No shops yet</h3>
        <p>Shops appear here once a creator publishes their first item.</p>
      }
    </div>
  } @else {
    <div class="shop-grid">
      @for (vendor of filteredVendors; track vendor.id) {
        <a class="shop-card" [routerLink]="['/store']" [queryParams]="{ author: vendor.shop_slug }">
          <span class="shop-card-banner" [style.background-image]="vendor.banner ? 'url(' + vendor.banner + ')' : null"></span>
          @if (vendor.logo) {
            <img class="shop-card-logo" [src]="vendor.logo" alt="" />
          } @else {
            <span class="shop-card-logo shop-card-logo--letter" aria-hidden="true">{{ vendor.shop_name.charAt(0).toUpperCase() }}</span>
          }

          <span class="shop-card-body">
            <span class="shop-card-name">{{ vendor.shop_name }}</span>
            <span class="shop-card-stats">
              <span>{{ vendor.listing_count ?? 0 }} item{{ vendor.listing_count === 1 ? '' : 's' }}</span>
              <span aria-hidden="true">·</span>
              <span>{{ followerCount(vendor) }} follower{{ followerCount(vendor) === 1 ? '' : 's' }}</span>
              @if (vendor.rating_count > 0) {
                <span aria-hidden="true">·</span>
                <span class="shop-card-rating">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>
                  {{ vendor.rating_avg | number: '1.1-1' }}
                </span>
              }
            </span>
            <span class="shop-card-bio" [class.is-empty]="!vendor.bio">{{ vendor.bio || 'No description yet.' }}</span>
          </span>

          <span class="shop-card-foot">
            @if (vendor.is_mine) {
              <span class="shop-card-mine">Your shop</span>
            } @else {
              <button
                type="button"
                class="shop-follow"
                [class.is-on]="isFollowing(vendor)"
                [disabled]="pendingFollowId === vendor.id"
                (click)="toggleFollow(vendor, $event)"
              >
                @if (isFollowing(vendor)) {
                  <svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                  Following
                } @else {
                  <svg viewBox="0 0 24 24" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                  Follow
                }
              </button>
            }
            <span class="shop-card-visit">
              Visit shop
              <svg viewBox="0 0 24 24" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
            </span>
          </span>
        </a>
      }
    </div>
  }
</div>
</main>
<app-footer></app-footer>
